import { render } from "./FraudexFeedbackModal.vue?vue&type=template&id=6cb9af6d&ts=true"
import script from "./FraudexFeedbackModal.vue?vue&type=script&lang=ts"
export * from "./FraudexFeedbackModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__